module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "ibox"
  }, [_c('div', {
    staticClass: "ibox-title"
  }, [_c('h5', [_vm._v("Automated Emails")]), _vm._v(" "), _c('div', {
    staticClass: "ibox-tools"
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "content": "Add new recipient",
      "placement": "left"
    }
  }, [_c('el-button', {
    staticClass: "ibox-tool-btn",
    attrs: {
      "type": "primary",
      "size": "small",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.manageRecipient(null)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])], 1), _vm._v(" "), (_vm.me.is_staff) ? _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "content": "Generate Report",
      "placement": "left"
    }
  }, [_c('el-button', {
    staticClass: "ibox-tool-btn",
    attrs: {
      "type": "primary",
      "size": "small",
      "plain": ""
    },
    on: {
      "click": _vm.generateReport
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope"
  })])], 1) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "ibox-content ibox-heading"
  }, [_vm._v("\n      Manage who can receive automated campaign, survey and programming dashboard reports.\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "ibox-content user-list-content"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.keyword),
      expression: "keyword"
    }],
    staticClass: "input form-control",
    attrs: {
      "type": "text",
      "placeholder": "Search..."
    },
    domProps: {
      "value": (_vm.keyword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.keyword = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.results,
      "fit": true,
      "empty-text": !_vm.results.length && _vm.recipients.length ?
        ("No recipients found matching " + _vm.keyword) :
        'No recipients',
      "max-height": "400",
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "Name"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', [_vm._v(_vm._s(((scope.row.firstName) + " " + (scope.row.lastName))))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Email",
      "prop": "email"
    }
  }), _vm._v(" "), (_vm.companies.length) ? _c('el-table-column', {
    attrs: {
      "label": "Company"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(scope.row.company.title) + "\n          ")]
      }
    }], null, false, 2276206164)
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Reports",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "client-status center"
        }, [_c('el-tooltip', {
          attrs: {
            "content": "Campaign Summary",
            "placement": "top"
          }
        }, [(scope.row.campaignSummary) ? _c('span', {
          staticClass: "label label-info"
        }, [_vm._v(" ")]) : _vm._e()]), _vm._v(" "), _c('el-tooltip', {
          attrs: {
            "content": "Survey Summary",
            "placement": "top"
          }
        }, [(scope.row.surveySummary) ? _c('span', {
          staticClass: "label label-warning-light"
        }, [_vm._v(" ")]) : _vm._e()]), _vm._v(" "), _c('el-tooltip', {
          attrs: {
            "content": "Programming Dashboard",
            "placement": "top"
          }
        }, [(scope.row.programmingSummary) ? _c('span', {
          staticClass: "label label-success"
        }, [_vm._v(" ")]) : _vm._e()]), _vm._v(" "), (
          !scope.row.campaignSummary &&
          !scope.row.surveySummary &&
          !scope.row.programmingSummary
        ) ? _c('span', [_c('i', [_vm._v("None")])]) : _vm._e()], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.manageRecipient(scope.row)
            }
          }
        }, [_vm._v("Edit")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.deleteRecipient(scope.row)
            }
          }
        }, [_vm._v("Delete")])]
      }
    }])
  })], 1)], 1)]), _vm._v(" "), (_vm.showRecipientManage) ? _c('el-dialog', {
    attrs: {
      "title": _vm.selectedRecipient.id ? 'Edit Automated Email Recipient' : 'New Automated Email Recipient',
      "visible": _vm.showRecipientManage,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.showRecipientManage = $event
      }
    }
  }, [(_vm.showRecipientManage) ? _c('recipient-manage', {
    attrs: {
      "recipient": _vm.selectedRecipient,
      "users": _vm.users,
      "me": _vm.me,
      "companies": _vm.companies
    },
    on: {
      "cancelled": function($event) {
        _vm.showRecipientManage = false
      },
      "saved": _vm.handleSaved,
      "deleted": _vm.handleDelete,
      "error": _vm.handleError
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.showGenerator) ? _c('el-dialog', {
    attrs: {
      "title": "Generate Automated Email",
      "visible": _vm.showGenerator,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.showGenerator = $event
      }
    }
  }, [_c('generate-report', {
    attrs: {
      "loading": _vm.generatingReport,
      "surveys": _vm.surveys,
      "campaigns": _vm.campaigns
    },
    on: {
      "generate": function($event) {
        return _vm.handleGenerate($event)
      },
      "cancel": function($event) {
        _vm.showGenerator = false
      }
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-primary"
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Search")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dc65c794","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/automatedemails/recipients/EmailRecipientList.vue
// module id = 3404
// module chunks = 3